import { jsx as o } from "react/jsx-runtime";
import t from "@kmx/mui-icons/KmxRadioButtonFilled";
import c from "@kmx/mui-icons/KmxRadioButtonStroked";
const d = {
  defaultProps: {
    checkedIcon: /* @__PURE__ */ o(t, {}),
    icon: /* @__PURE__ */ o(c, {})
  }
};
export {
  d as default
};
